import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  CssBaseline,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { allIcons, appLogo } from "../../assets";
import appcolors from "../../constants/Colors";
import useRoleWiseRoutes from "../../hooks/useRoleWiseRoutes";
import useNotifications from "../hooks/useNotifications";
import ProfileMenu from "../MenuDropDown/ProfileMenu";
import { AppBar, Drawer, DrawerHeader } from "./DrawerTheme";
import LanguageMenu from "../LanguageMenu";
import { t } from "i18next";

const NavigationDrawer = ({ children }) => {
  const { routesToRender } = useRoleWiseRoutes();

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [open, setOpen] = useState(false);
  const userData = useSelector((state) => state.userData.user);
  const {
    notificationsLoading,
    allNotifications,
    fetchAllNotifications,
    markUserNotificationRead,
  } = useNotifications();

  React.useEffect(() => {
    if (window?.location.pathname !== `/${userData?.role}/notifications`) {
      fetchAllNotifications();
    }
  }, []);

  const handleDrawerOpen = () => {
    setOpen(false);
  };

  const returnActive = (val, path) => val === path;

  let filterArrr = allNotifications?.filter(
    (itemmmm) => !itemmmm.userStatus.isRead
  );

  console.log(userData, routesToRender, "sadasdksadsadkjsajkdjksadkjsa");

  const disabledWorkerTabes =
    userData?.role === "worker" && userData?.availability?.length === 0;
  const diableFreeWorkerTabs = userData?.role === "worker" && userData?.isFree === true;

  return (
    <Box display={"flex"} bgcolor={"#F5F5F5"} minHeight={"100vh"}>
      <CssBaseline />

      {/* App Bar */}
      <AppBar position="fixed" open={open} sx={{ top: "0" }}>
        <Toolbar
          sx={{
            minHeight: "inherit !important",
            justifyContent: "space-between",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ marginRight: 5, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <Stack gap={2} direction={"row"}>
            {/* <Tooltip title="Customer support">
              <IconButton
                onClick={() => navigate("/customer-support")}
                sx={{
                  p: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <img src={allIcons.chatIcon} alt={"icon"} width={30} />
              </IconButton>
            </Tooltip> */}
            <LanguageMenu />

            {window.location.pathname !==
              `/${userData?.role}/notifications` && (
              <Stack>
                <IconButton
                  sx={{ position: "relative" }}
                  onClick={() => {
                    markUserNotificationRead();
                    navigate(`/${userData?.role}/notifications`);
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      background: "#7922d8",
                      top: 0,
                      right: 0,
                      height: "20px",
                      width: "20px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography sx={{ color: "#ffff", fontSize: "12px" }}>
                      {filterArrr.length}
                    </Typography>
                  </Box>
                  <img
                    src={allIcons.notificatioHeaderIcon}
                    alt="notification-icon"
                    style={{
                      width: 25,
                    }}
                  />
                </IconButton>
              </Stack>
            )}

            {/* <NotificationMenu /> */}
            <ProfileMenu />
          </Stack>
        </Toolbar>
      </AppBar>

      {/* Navigation Drawer */}

      <Drawer
        variant="permanent"
        open={open}
        sx={{
          "& .MuiPaper-root": {
            paddingTop: "20px",
            "&::-webkit-scrollbar": {
              // display:"none",
              width: "4px",
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: appcolors.slateGrey,
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: appcolors.secondary,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: appcolors.white,
            },
          },
        }}
      >
        <DrawerHeader>
          {/* <IconButton sx={{ display: "none" }} onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton> */}
          {/* <Box
            component={"img"}
            src={appLogo.eazidayLogo}
            alt={"app-logo"}
            width={35}
            height={"auto"}
          /> */}
          <Box
            component={"img"}
            src={appLogo.eazidayLogoNew}
            alt={"app-logo"}
            width={35}
            height={"auto"}
          />
        </DrawerHeader>
        <Typography
          mt={0.5}
          variant="h3"
          fontSize={"0.813rem"}
          fontWeight={"600"}
          textAlign={"center"}
          color={"#868E96"}
          textTransform={"uppercase"}
        >
          {t("mainMenu")}
        </Typography>
        <List disablePadding sx={{ mt: 2, p: "3px" }}>
          {routesToRender.map((val, index) => {
            let isMatched = returnActive(val.path, pathname);
            return (
              <ListItem
                key={index}
                disablePadding
                disabled={
                  (disabledWorkerTabes && val.path !== "/worker/schedule") || (diableFreeWorkerTabs && val.path === "/worker/subscription")
                }
                sx={{
                  mb: "5px",
                  display: "block",
                  borderRadius: "10px",
                  backgroundColor: isMatched
                    ? appcolors.primary
                    : "transparent",
                }}
              >
                <ListItemButton
                  disabled={
                    (disabledWorkerTabes && val.path !== "/worker/schedule") || (diableFreeWorkerTabs && val.path === "/worker/subscription")
                  }
                  disableRipple
                  onClick={() => {
                    if (val.path == `/${userData?.role}/notifications`) {
                      markUserNotificationRead();
                      navigate(val.path);
                    } else navigate(val.path);
                  }}
                  sx={{
                    minHeight: 60,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "0.3s",
                    borderRadius: "10px",

                    "&:hover": {
                      ...(!isMatched && { backgroundColor: "#F3EBFF" }),
                    },
                  }}
                >
                  <img
                    src={isMatched ? val.iconActive : val.icon}
                    alt={val.name}
                    width={25}
                    style={{ mb: 1 }}
                  />
                  <ListItemText
                    primary={t(val.name)}
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontSize: "0.75rem",
                        transition: "0.3s",
                        color: isMatched ? appcolors.white : appcolors.black,
                        whiteSpace: "break-spaces",
                      },
                      textAlign: "center",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>

      {/* rendering components */}
      <Box
        component="main"
        sx={{ flexGrow: 1, p: "15px 1rem 24px", overflow: "auto" }}
      >
        <DrawerHeader />
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default NavigationDrawer;
